module.exports = __webpack_public_path__ + "img/3.0f4cdb5.png";